import { useTranslation } from "react-i18next";
import React, { Fragment, useState, useEffect } from "react";
import { Grid, Box, Typography, TextField, MenuItem } from "@mui/material";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { useLocalStorage, useSessionStorage } from "../../utils/hooks";

function Modulgruppenfilter({
  gruppen,
  mitarbeiter,
  onMitarbeiterChange,
  onGruppeChange,
  selectedMitarbeiter,
  selectedGruppe,
  kz,
  small,
  nobox,
  notitle
}) {
  const { t } = useTranslation();

  function onChange(art, value) {
    if (art === "g") {
      onGruppeChange(value);
    }
    if (art === "u") {
      onMitarbeiterChange(value);
      var tmp = gruppen.findIndex((e) => e.key === selectedGruppe);
      
      if (
        tmp !== -1 &&
        value !== "A" &&
        gruppen[tmp].art &&
        gruppen[tmp].art !== "A" &&
        ((gruppen[tmp].art !== "S" &&
          gruppen[tmp].art.includes(value) === false) ||
          (gruppen[tmp].art === "S" &&
            gruppen[tmp].vg.includes(value) === false))
      ) {
        onGruppeChange("A");
      }
    }
  }
  return (
    <Fragment>
      <Box p={!nobox ? 2 : 0}>
        <Grid container justifyContent="center" spacing={2}>
          {!notitle && (
            <Grid item xs={12}>
              <Typography>{t("Filter")}</Typography>
            </Grid>
          )}
          <Grid item xs={12} lg={kz === "full" ? 6 : 12}>
            <TextField
              select
              size={small ? "small" : "medium"}
              fullWidth
              variant="outlined"
              label={t("Mitarbeiter")}
              value={selectedMitarbeiter}
              onChange={(e) => {
                onChange("u", e.target.value);
              }}
            >
              {mitarbeiter.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.key} index={index}>
                    {item.bez}
                  </MenuItem>
                );
              })}
            </TextField>
          </Grid>
          <Grid item xs={12} lg={kz === "full" ? 6 : 12}>
            <TextField
              select
              size={small ? "small" : "medium"}
              fullWidth
              variant="outlined"
              label={t("Gruppen")}
              value={selectedGruppe}
              onChange={(e) => {
                onChange("g", e.target.value);
              }}
            >
              {gruppen &&
                gruppen
                  .filter((tmp) => {
                    if (selectedMitarbeiter === "A") return true;
                    if (tmp.key === "A") return true;
                    if (tmp.art && tmp.art.includes(selectedMitarbeiter))
                      return true;
                    if (
                      tmp.art &&
                      tmp.art === "S" &&
                      tmp.vg &&
                      tmp.vg.includes(selectedMitarbeiter)
                    )
                      return true;
                    return false;
                  })
                  .map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.key} index={index}>
                        {item.bez}
                      </MenuItem>
                    );
                  })}
            </TextField>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  );
}
export default Modulgruppenfilter;
